<template>
    <div>
        <h5 v-if="serial"><strong>Part Number:</strong> {{ serial }}</h5>
        <b-progress :value="progressStep" :max="progressMax" animated></b-progress>
    </div>
</template>

<script>
    export default {
        props: {
            serial: {type: String, required: true},
            progressStep: {type: Number, required: true},
            progressMax: {type: Number, default: 10}
        }
    }
</script>

<style scoped>

</style>
